import React from "react";
import { Award, Users, Leaf } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CalidadYOrigen() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const features = [{
    title: "Calidad",
    description: "Nuestra búsqueda de la excelencia es incansable. Cada aceituna es seleccionada en su punto óptimo de maduración para garantizar un aceite de oliva virgen extra de categoría superior, con aromas frescos y un sabor inigualable que define nuestra identidad.",
    icon: <Award strokeWidth={1.5} className="w-12 h-12" />
  }, {
    title: "Origen familiar",
    description: "Más que una empresa, somos una familia dedicada al olivar durante generaciones. Nuestras raíces están profundamente ancladas en la tierra, transmitiendo el amor por el campo y la sabiduría tradicional de padres a hijos con orgullo y dedicación.",
    icon: <Users strokeWidth={1.5} className="w-12 h-12" />
  }, {
    title: "Producción responsable",
    description: "Respetamos la naturaleza que nos da vida. Implementamos prácticas agrícolas sostenibles que protegen la biodiversidad de nuestros olivares, asegurando que la tierra permanezca fértil y viva para el futuro, cuidando cada paso del proceso.",
    icon: <Leaf strokeWidth={1.5} className="w-12 h-12" />
  }];
  return <section id="calidad-y-origen" className="bg-white py-12 md:py-9 lg:py-12" ref={ref}>
      <div className="container max-w-6xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-16">
          {features.map((feature, i) => <div key={i} data-index={i} className={`flex flex-col items-start space-y-6 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`} style={{
          transitionDelay: `${i * 200}ms`
        }}>
              <div className="text-primary">
                {feature.icon}
              </div>
              <h3 className="font-serif font-medium text-3xl text-foreground">
                {feature.title}
              </h3>
              <p className="font-sans text-foreground/80 leading-relaxed">
                {feature.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}